import { gql } from '@apollo/client'
import MESSAGE_FRAGMENT from 'apollo/fragments/MESSAGE_FRAGMENT'

// MESSAGES_EVENTS

export default gql`
  subscription messagesEvents($chat_id: ID) {
    messages_events(chat_id: $chat_id) {
      event_type
      message {
        ...MESSAGE_FRAGMENT
      }
    }
  }
  ${MESSAGE_FRAGMENT}
`
